import { z } from 'zod';

export const payTypeSchema = z.enum(['SALARIED', 'HOURLY']);
export type PayType = z.infer<typeof payTypeSchema>;

export const employmentTypeSchema = z.enum(['TARIF', 'AT']);
export type EmploymentType = z.infer<typeof employmentTypeSchema>;

const salaryRangeSchema = z.object({
    maximum: z.number(),
    midpoint: z.number(),
    minimum: z.number(),
});
export type SalaryRange = z.infer<typeof salaryRangeSchema>;

const payDataSchema = z.object({
    employmentType: employmentTypeSchema,
    longTermIncentive: z.string(),
    payGrade: z.string(),
    payType: payTypeSchema,
    salary: salaryRangeSchema,
    targetBonus: z.number().min(0).max(1),
});
export type PayData = z.infer<typeof payDataSchema>;

export const careerTrackLevelSchema = z.object({
    description: z.string(),
    level: z.number().int().min(1),
    name: z.string(),
    payData: payDataSchema.nullable().optional(),
    progressionCriteria: z.string().nullable().optional(),
});

export type CareerTrackLevel = z.infer<typeof careerTrackLevelSchema>;

export const careerTrackSchema = z.object({
    id: z.uuid(),
    description: z.string(),
    levels: careerTrackLevelSchema.array(),
    name: z.string(),
});

export type CareerTrack = z.infer<typeof careerTrackSchema>;
